import { Button, Input, Modal } from "antd";
import React, { useState } from "react";
import { Note } from "../../../components/Note";
import { API } from "../../../core/api";
import FormWrapper from "../../../components/FormWrapper/FormWrapper";
import { checkValidEngNumbers, toEnglishNumber } from "../../../core/utils";
import CloseModalButton from "../../../components/CloseModalButton/CloseModalButton";

const AddEmployee = ({ getEmployees }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [employeeData, setEmployeeData] = useState({
    first_name: "",
    last_name: "",
    phone_number: "",
    national_id: "",
    post: "",
  });

  const onSetEmployee = () => {
    const newEmployee = {
      ...employeeData,
      national_id: toEnglishNumber(employeeData.national_id),
      phone_number: toEnglishNumber(employeeData.phone_number),
    };
    if (!newEmployee.first_name) {
      return Note.error("Please enter first name");
    }
    if (!newEmployee.last_name) {
      return Note.error("Please enter last name");
    }
    if (!newEmployee.phone_number) {
      return Note.error("Please enter phone number");
    }
    if (!newEmployee.post) {
      return Note.error("Please enter post");
    }
    delete newEmployee.province;
    // API.post.set_company_employee(newEmployee).then((response) => {
    //   if (response.success) {
    //     Note.success(response.message);
    //     setIsModalOpen(false);
    //     getEmployees();
    //     setEmployeeData({
    //       first_name: "",
    //       last_name: "",
    //       phone_number: "",
    //       national_id: "",
    //       post: "",
    //     });
    //   } else {
    //     Note.error(response.message);
    //   }
    // });
  };

  const handleChange = (data) => {
    setEmployeeData({ ...employeeData, ...data });
  };

  return (
    <div className=" w-100">
      <div className=" ">
        <Button
          onClick={() => setIsModalOpen(true)}
          className="button-primary w-220px flex flex-items-center flex-content-center"
        >
          <i className="far fa-plus pr-4 pb-8" />
          <span>Add Employee</span>
        </Button>
      </div>
      <Modal
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          setEmployeeData({
            first_name: "",
            last_name: "",
            phone_number: "",
            national_id: "",
            province: null,
            city_id: null,
            post: "",
          });
        }}
        footer={null}
        closable={true}
        title="Add Employee"
        bodyStyle={{
          paddingBottom: 8,
          paddingLeft: 0,
          paddingRight: 0,
        }}
        closeIcon={
          <CloseModalButton isCloseIcon close={() => setIsModalOpen(false)} />
        }
      >
        <div className="px-20 pb-20 w-100 ">
          <FormWrapper>
            <Input
              className="input-black border-black-8
 "
              placeholder="First Name"
              value={employeeData.first_name}
              onChange={(e) => handleChange({ first_name: e.target.value })}
            />
            <Input
              className="input-black border-black-8
 "
              placeholder="Last Name"
              value={employeeData.last_name}
              onChange={(e) => handleChange({ last_name: e.target.value })}
            />
            <Input
              className="input-black border-black-8"
              placeholder="National ID"
              value={employeeData.national_id}
              onChange={(e) => handleChange({ national_id: e.target.value })}
              onKeyDown={checkValidEngNumbers}
              maxLength={10}
            />
            <Input
              className="input-black border-black-8"
              placeholder="Post"
              value={employeeData.post}
              onChange={(e) => handleChange({ post: e.target.value })}
            />
            <Input
              className="input-black border-black-8"
              placeholder="Phone Number"
              value={employeeData.phone_number}
              onChange={(e) => handleChange({ phone_number: e.target.value })}
              onKeyDown={checkValidEngNumbers}
              maxLength={11}
            />
            <Button className="button-primary " onClick={onSetEmployee}>
              Add Employee
            </Button>
          </FormWrapper>
        </div>
      </Modal>
    </div>
  );
};

export default AddEmployee;
